import React, { useState, useEffect } from "react";
import "./calendar.css";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { FaPlus } from "react-icons/fa";
import api from '../../service/caller';
import { useParams } from "react-router-dom";

const CalendarView = () => {
  const { doctorId } = useParams();
  const [events, setEvents] = useState([]);
  const [blockedDates, setBlockedDates] = useState([]);
  const [showAddEventModal, setShowAddEventModal] = useState(false);
  const [showBlockDateModal, setShowBlockDateModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [newEventTitle, setNewEventTitle] = useState("");
  const [newEventTime, setNewEventTime] = useState("");

  // Appel de l'API pour récupérer les rendez-vous du médecin pour une date donnée
  const fetchDoctorAppointments = async (date) => {
    try {
        const response = await api.get(`/clinic/reservedSlots?doctorId=${doctorId}`);

        console.log('API Response:', response.data);

        // Validation des données reçues
        if (!Array.isArray(response.data)) {
            throw new Error('Invalid data format from API');
        }

        // Transformation des données pour FullCalendar
        const formattedEvents = response.data.map(event => ({
            ...event,
            // S'assurer que la date de début est valide
            start: event.start || new Date(`${date}T00:00:00`).toISOString(),
            // Propriétés d'affichage
            display: 'auto',
            backgroundColor: event.color,
            borderColor: event.color,
            textColor: '#ffffff'
        }));
        setEvents(formattedEvents);
        console.log("Formatted Events for FullCalendar:", formattedEvents);
    } catch (error) {
        console.error("Error fetching appointments:", {
            message: error.message,
            response: error.response?.data
        });
        // Option: Afficher un message d'erreur à l'utilisateur
    }
};


  // Quand la date change, récupérer les rendez-vous pour cette date
  useEffect(() => {
    if (selectedDate) {
      fetchDoctorAppointments(selectedDate); // Récupérer les rendez-vous à chaque fois que la date change
    }
  }, [selectedDate]);

  // Fonction pour gérer le clic sur une date
  const handleDateClick = (info) => {
    const clickedDate = info.date.toISOString().split("T")[0];
    setSelectedDate(clickedDate); // Mettre à jour la date sélectionnée
    setShowAddEventModal(true); // Afficher le modal pour ajouter un événement
  };

  // Ajouter un événement
  const handleAddEvent = () => {
    if (newEventTitle.trim() && selectedDate && newEventTime) {
      const eventDateTime = `${selectedDate}T${newEventTime}`;
      setEvents([
        ...events,
        { title: newEventTitle, start: eventDateTime, textColor: "green" },
      ]);
      setNewEventTitle(""); // Réinitialiser le titre de l'événement
      setNewEventTime(""); // Réinitialiser l'heure de l'événement
      setShowAddEventModal(false); // Fermer le modal après l'ajout
    }
  };

  // Bloquer une date
  const handleBlockDate = () => {
    setBlockedDates([...blockedDates, selectedDate]);
    setShowBlockDateModal(false);
  };

  return (
    <div>
      <h2 className="fw-bold" style={{ color: "#0056B3", fontSize: "42px", marginBottom: "70px" }}>
        Votre calendrier
      </h2>

      <div className="bg-white p-4 modalcalendar text-dark">
        <Fullcalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView={"timeGridWeek"}
          headerToolbar={{
            start: "today",
            center: "title",
            end: "timeGridWeek,timeGridDay prev,next",
          }}
          events={events} // Affichage des événements existants
          dateClick={handleDateClick} // Permet de cliquer sur une date
          height={"90vh"}
          eventDisplay="block"
          eventTimeFormat={{
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }}
          slotMinTime="08:00:00"
          slotMaxTime="19:00:00"
          dayCellClassNames={(info) => {
            const currentDate = info.date.toISOString().split("T")[0];
            if (blockedDates.includes(currentDate)) {
              return "blocked-date";
            }
            return "";
          }}
          dayCellContent={(info) => {  // Remplacer dayRender par dayCellContent
            if (info.view.type === "timeGridWeek") {
              return (
                <>
                  <div className="fc-daygrid-day-number">{info.dayNumberText}</div>
                  <div className="add-event-icon" onClick={() => handleDateClick(info)}>
                    <FaPlus size={20} color="green" />
                  </div>
                </>
              );
            }
          }}
        />

        {/* Modal pour ajouter un événement */}
        {showAddEventModal && (
          <div className="modal">
            <div className="modal-content">
              <h3>Ajouter un événement</h3>
              <p>Date sélectionnée : {selectedDate}</p>
              <input
                type="text"
                placeholder="Titre de l'événement"
                value={newEventTitle}
                onChange={(e) => setNewEventTitle(e.target.value)}
              />
              <label>
                Heure :
                <input
                  type="time"
                  value={newEventTime}
                  onChange={(e) => setNewEventTime(e.target.value)}
                />
              </label>
              <div className="modal-actions">
                <button onClick={handleAddEvent}>Ajouter</button>
                <button onClick={() => setShowBlockDateModal(true)}>Bloquer cette date</button>
                <button onClick={() => setShowAddEventModal(false)}>Annuler</button>
              </div>
            </div>
          </div>
        )}

        {/* Modal pour bloquer une date */}
        {showBlockDateModal && (
          <div className="modal">
            <div className="modal-content">
              <h3>Bloquer cette période</h3>
              <p><strong>Si vous bloquez cette date, aucun rendez-vous ne pourra être pris pour cette période.</strong></p>
              <div className="modal-actions d-flex justify-content-between">
                <hr />
                <button onClick={() => setShowBlockDateModal(false)} className="bg-primary">Fermer</button>
                <button onClick={handleBlockDate} className="bg-dark">Oui</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarView;
